<template>
  <mf-tabs-button v-model="chartType" class="ml-2" size="sm" :buttons="buttons" />
</template>

<script>
export default {
  props: {
    type: String,
  },
  computed: {
    chartType: {
      get() {
        return this.type
      },
      set(value) {
        this.$emit('update:type', value)
      },
    },
    buttons() {
      return [
        {
          id: 0,
          icon: 'bar_chart',
          value: 'bar',
          active: true,
        },
        {
          id: 1,
          icon: 'show_chart',
          value: 'line',
          active: true,
        },
      ]
    },
  },
}
</script>
